module.exports = __webpack_public_path__ + "static/img/profile-bg.55798a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/profile-bg.png
// module id = UcNu
// module chunks = 0